<div class="modal-header">
  <div>
    <h4 class="modal-title">Cargar nuevo arte</h4>
    <small>{{ data.medio }} - {{ data.pop }} - {{ data.fase }}</small>
  </div>
  <button type="button" class="btn-close" mat-dialog-close [disabled]="cargando" aria-label="Cerrar"></button>
</div>

<mat-dialog-content>
  <div class="modal-body">
    <p>Selecciona un PDF o una o varias imágenes JPG, JPEG, PNG o WEBP para crear una nueva versión del arte compartido.</p>
    <form [formGroup]="form">
      <ngx-file-drag-drop
        class="ngx-file_f"
        emptyPlaceholder="Arrastra o selecciona imágenes o un PDF"
        accept="image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp,application/pdf,.pdf"
        [multiple]="true"
        [disabled]="cargando"
        formControlName="blob"
        (valueChanged)="onValueChange($event)">
      </ngx-file-drag-drop>
    </form>
  </div>
</mat-dialog-content>

<div class="modal-footer">
  <button mat-button mat-dialog-close [disabled]="cargando">Cancelar <mat-icon>close</mat-icon></button>
  <button mat-flat-button color="primary" (click)="subirArchivo()" [disabled]="cargando || form.invalid">
    Subir archivo <mat-icon>upload</mat-icon>
  </button>
</div>
